import React from "react"
import Button from "../../button/Button"
import ProductFooter from "../footer/ProductFooter"
import { graphql } from "gatsby"
import { IFullProductProps } from "../gridLayout2/FullWidthPromoModules"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import CustomBadge from "../../badges/CustomBadge"
import Price from "../../shopifyProduct/Price"

const FullProduct: React.FC<IFullProductProps> = ({
  backgroundImage,
  product,
  icon,
  button,
  footer,
}) => {
  const gatsbyImageIcon = icon && getImage(icon.gatsbyImage)
  const gatsbyImageBg = backgroundImage && getImage(backgroundImage.gatsbyImage)

  return (
    <div className="relative mx-auto flex min-h-[517px] max-w-[1260px] flex-col items-center bg-cover bg-bottom bg-no-repeat pt-[97px] text-white md:px-[60px]">
      <div className="absolute top-0 left-0 h-full w-full ">
        {gatsbyImageBg && (
          <GatsbyImage
            loading="eager"
            image={gatsbyImageBg}
            alt={backgroundImage.altText}
            className="absolute top-0 left-0 h-full w-full "
          />
        )}
      </div>
      <div className="relative z-10 mx-auto flex w-full max-w-7xl flex-col items-end px-[15px] pb-[33px]">
        {product?.acfProduct?.badge?.enabled && (
          <CustomBadge
            label={product.acfProduct.badge.label}
            backgroundColor={product.acfProduct.badge.backgroundColor}
          />
        )}
        {gatsbyImageIcon && (
          <GatsbyImage
            loading="eager"
            image={gatsbyImageIcon}
            alt={icon.altText}
            className=" mt-[15px] rounded"
          />
        )}
        <p className="mt-[18px] text-promoModulePriceCrossed font-semibold">
          {product?.product?.title}
        </p>
        <p className="mt-0.5 max-w-[475px] text-right text-body1">
          {product?.acfProduct?.shortDescription}
        </p>
        <div className="mt-[15px] flex items-center space-x-3 text-promoModulePriceCrossed">
          {product?.product?.variants && (
            <Price
              variant="promo"
              price={product?.product?.variants[0].price}
              compareAtPrice={product?.product?.variants[0].compareAtPrice}
            />
          )}
        </div>
        {(button || product?.link) && (
          <Button
            to={button?.url || product?.link || "/"}
            className="mt-[22px] px-[50px] py-1"
          >
            {button?.title || "Buy"}
          </Button>
        )}
      </div>
      {footer?.headline && <ProductFooter {...footer} />}
    </div>
  )
}

export default FullProduct

export const fragment = graphql`
  fragment FullProduct on WpDefaultTemplate_Acf_Modules_Promos_Promos_GridLayout2 {
    fieldGroupName
    blocks {
      ... on WpDefaultTemplate_Acf_Modules_Promos_Promos_GridLayout2_Blocks_Product {
        fieldGroupName
        icon {
          altText
          gatsbyImage(
            placeholder: BLURRED
            quality: 100
            width: 320
            height: 90
            fit: OUTSIDE
            formats: [AUTO, WEBP]
          )
        }
        button {
          title
          url
        }
        backgroundImage {
          altText
          gatsbyImage(
            quality: 85
            layout: FULL_WIDTH
            width: 1226
            height: 517
            formats: [AUTO, WEBP]
          )
        }
        footer {
          headline
          link {
            target
            title
            url
          }
        }
        product {
          ... on WpProduct {
            link
            acfProduct {
              badge {
                enabled
                label
                backgroundColor
              }
              shortDescription
            }
            product {
              description
              title
              variants {
                compareAtPrice
                price
              }
            }
          }
        }
      }
    }
  }
`
